module.exports = __webpack_public_path__ + "static/media/module-order.71fa85e9.png";